import Swiperone from "../classes/Swiperone";
import BookLoftForm from "../classes/BookLoftForm";

export default class Home {
  constructor(page, data) {
    this.page = page;
    this.data = data;
  }

  init() {
    this.initMainHeaderHome();
    this.initSwipers();
    // this.initTabs();
    this.initInlineBlocks();
    this.initBookLoftForm();
    // this.initBeersForms();
    this.initEventsAccordions();
    // this.initHubServicesThumbs();
  }  

  initSwipers() {
    this._initMainHeaderSwiper();
    this._initFlagshipsSwiper();
    this._initBookLoftSwiper();
    this._initBeersSwiper();
    this._initEventsSwiperone();
    this._initSpacesSwiperone()
    this._initSpacesCorpSwiper();
    this._initGallerySwipers();
    this._initServicesSwipers();
    this._initSwiperPromos();
    this._initHubSwiperServices();
    this._initIndexedSwipers();
  }

  _initMainHeaderSwiper() {
    const swiper = new Swiper(this.page.querySelector(".js-main-header-swiper"), {
      effect: "fade",
      autoplay: true,
      speed: 5000,
      delay: 10000
    });
  }

  _initFlagshipsSwiper() {
    const swiper = new Swiper(this.page.querySelector(".js-swiper-flagship"), {
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: ".js-swiper-flagship-button-next",
        prevEl: ".js-swiper-flagship-button-prev"
      },
      slidesPerView: 1.3,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 4.2,
        }
      }
    });
  }

  _initBeersSwiper() {
    const swipers = this.page.querySelectorAll(".js-swiper-beers");
    swipers?.forEach(swiper => {
      const swiperBeers = new Swiper(swiper, {
        loop: false,
        navigation: {
          nextEl: swiper.querySelector(".js-swiper-beers-button-next"),
          prevEl: swiper.querySelector(".js-swiper-beers-button-prev")
        },
        centeredSlides: false,
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 4.25,
          }
        },
        grabCursor: true
      });
    });
  }

  _initBookLoftSwiper() {
    const loftSwipers = this.page.querySelectorAll(".js-book-loft-swiper");
    loftSwipers?.forEach(loftSwiper => {
      const swiper = new Swiper(loftSwiper, {
        effect: "fade",
        autoplay: true,
        speed: 5000,
        delay: 10000
      });
    })    
  }

  _initEventsSwiperone() {
    const swiperonies = this.page.querySelectorAll(".js-swiper-events");
    swiperonies?.forEach((swiper) => {
      const swiperone = new Swiperone(swiper, {
          draggable: true,
          pagination: true,
          excerpt: ".js-current-event-desc",
          btnLink: ".js-btn-event-cta"
        }
      );
      swiperone?.init();
    });
  }

  _initSpacesSwiperone() {
    const swiperonies = this.page.querySelectorAll(".js-swiper-spaces");
    swiperonies?.forEach((swiper) => {
      const swiperone = new Swiperone(swiper, {
          draggable: true,
          pagination: true,
          excerpt: ".js-current-space-desc",
          btnLink: ".js-btn-space-cta"
        }
      );
      swiperone?.init();
    });
  }

  _initSpacesCorpSwiper() {
    const corpsSwipers = this.page.querySelectorAll(".js-swiper-spaces-corp");
    corpsSwipers?.forEach(corpSwiper => {
      const swiper = new Swiper(corpSwiper, {
        centeredSlides: false,
        loop: false,
        navigation: {
          nextEl: corpSwiper.querySelector(".js-swiper-spaces-corp-button-next"),
          prevEl: corpSwiper.querySelector(".js-swiper-spaces-corp-button-prev")
        },
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2.5
          },
          992: {
            slidesPerView: 3.5
          }
        },
        grabCursor: true
      });
    })    
  }

  _initSwiperPromos() {
    const swipers = this.page.querySelectorAll(".js-swiper-promos");
    swipers?.forEach(swiperPromo => {
      const swiper = new Swiper(swiperPromo, {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        preventClicks: true,
        preventClicksPropagation: true,
        breakpoints: {
          768: {
            slidesPerView: 4
          }
        },
        navigation: {
          nextEl: swiperPromo.querySelector(".js-swiper-button-next"),
          prevEl: swiperPromo.querySelector(".js-swiper-button-prev")
        }
      });

      this._initPromoAccordions(swiperPromo);      
    });    
  }

  _initPromoAccordions(swiper) {
    this._cleanPromoAccordionHeighs(swiper);
    
    swiper?.querySelectorAll(".js-promo")?.forEach(promo => {       
      promo.addEventListener("click", (e) => {
        if (swiper.querySelector(".js-promo.is-open") !== promo) {
          swiper.querySelector(".js-promo.is-open img")?.setAttribute("src", swiper.querySelector(".js-promo.is-open img").dataset.imgpos);
          swiper.querySelector(".js-promo.is-open")?.classList.remove("is-open");
        }         
        if (!promo.classList.contains("is-open")) {
          promo.classList.add("is-open");
          promo.querySelector("img")?.setAttribute("src", promo.querySelector("img").dataset.imgneg);
        } else {
          promo.classList.remove("is-open");
          promo.querySelector("img")?.setAttribute("src", promo.querySelector("img").dataset.imgpos);
        }        
      })
    });
  }

  _cleanPromoAccordionHeighs(swiper) {
    if (swiper) {
      const promos = swiper.querySelectorAll(".js-promo");
      const h = this._getPromoHeights(promos);
      this._setPromoHeights(promos, h);

      let resizing;
      window.addEventListener("resize", (e) => {
        clearTimeout(resizing);
        resizing = setTimeout(() => {
          const h = this._getPromoHeights(promos);
          this._setPromoHeights(promos, h);
        }, 250);
      })
    }
  }

  _getPromoHeights(promos) {
    let h = 0;
    promos?.forEach(promo => {
      promo.removeAttribute("style");
      
      if (promo.offsetHeight > h) {
        h = promo.offsetHeight;
      }
    });

    if (promos) {
      return h;
    }
    return undefined;
  }

  _setPromoHeights(promos, h) {
    promos?.forEach(promo => {
      promo.style.minHeight = `${h}px`;      
    });
  }

  _initIndexedSwipers() {
    let noMoreSwipers = false;
    let i = 1;

    while (!noMoreSwipers) {
      const swiperNode = this.page.querySelector(`.js-swiper-${i}`);

      if (swiperNode) {
        const swiper = new Swiper(swiperNode, {
          autoplay: true,
          grabCursor: true,
          disableOnInteraction: true
        });

        i++;

      } else {
        noMoreSwipers = true;
        break;
      } 
    }
  }

  _initGallerySwipers() {
    const swipers = this.page.querySelectorAll(".js-swiper-gallery");
    swipers?.forEach(swiper => {
      const swiperGallery = new Swiper(swiper, {
        autoplay: true,
        grabCursor: true,
        disableOnInteraction: true,
        navigation: {
          nextEl: swiper.querySelector(".js-swiper-gallery-button-next"),
          prevEl: swiper.querySelector(".js-swiper-gallery-button-prev")
        }
      });
    });
  }

  _initServicesSwipers() {
    const swipers = this.page.querySelectorAll(".js-swiper-services-controller");
    swipers?.forEach(swiper => {
      const swiperServiceThumb = new Swiper(swiper, {
        loop: false,
        spaceBetween: 5,
        grabCursor: true,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,  
      });
      const swiperService = new Swiper(swiper.nextElementSibling, {
        loop: false,
        spaceBetween: 20,
        grabCursor: true,
        navigation: {
          nextEl: ".js-swiper-service-button-next",
          prevEl: ".js-swiper-service-button-prev",
        },
        thumbs: {
          swiper: swiperServiceThumb,
        },  
      });
    });
  }

  _initHubSwiperServices() {
    const swiperBtns = this.page.querySelectorAll(".hub-info .hub-services .js-hub-service");
    const swiper = new Swiper(this.page.querySelector(".hub-info .js-swiper-services"), {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      disableOnInteraction: true,
    });

    if (swiper) {
      if (!swiperBtns[0]?.classList.contains("is-active")) swiperBtns[0]?.classList.add("is-active");      
      
      swiper.on("slideChange", () => {
        const btn = swiperBtns[swiper.activeIndex];
        if (btn) {
          btn.parentNode.querySelector(".is-active")?.classList.remove("is-active");
          if (!btn.classList.contains("is-active")) btn.classList.add("is-active");
        }         
      });    

      swiperBtns?.forEach((btn, i) => {
        btn.addEventListener("click", (e) => {
          if (btn.parentNode.querySelector(".is-active") !== btn) btn.parentNode.querySelector(".is-active")?.classList.remove("is-active");
          if (!btn.classList.contains("is-active")) btn.classList.add("is-active");
          swiper.slideTo(i);
        });
      });
    }   
  }

  initMainHeaderHome() {
    const mainHeader = this.page.querySelector(".js-main-header-home");
    if (mainHeader) {
      const parent = mainHeader.parentNode;
      const nav = parent.previousElementSibling;
      const headerSwiper = mainHeader.querySelector(".swiper");
      const elemsArr = new Array(nav, headerSwiper);
      const everyOtherEls = elemsArr.concat(Array.from(parent.children).filter(el => el !== mainHeader));

      document.querySelector("html").style.height = "100%";
      document.querySelector("html").classList.add("overflow-hidden");      
      parent.style.backgroundColor = "#000";
      this._hideOtherEls(everyOtherEls);
      this._alternateWords(mainHeader, everyOtherEls);      
    }
  }

  _hideOtherEls(arr) {
    arr?.forEach(el => {
      if (el !== null && el !== undefined) {
        el.style.opacity = 0;
        el.style.pointerEvents = "none";
      }
    });
  }

  _alternateWords(mainHeader, everyOtherEls) {
    let timing = 0;    
    const finalWordNode = mainHeader.querySelector(".js-final-word");
    if (finalWordNode) {
      const finalWord = finalWordNode.textContent;

      JSON.parse(mainHeader.querySelector(".header-title-cont")?.dataset.words)?.forEach((arr, i) => {
        const word = arr[0];
        const bgColor = arr[1];
        
        if (word && bgColor) {
          timing += 500;

          setTimeout(() => {
            finalWordNode.textContent = word.replace(/^[\s]+/, "");
            finalWordNode.style.cssText = `
              padding: .01em .2em;
              color: #000;
              background-color: ${bgColor};
            `;

            if (i === arr.length - 1) {              
              setTimeout(() => {
                this._showFinalWord(finalWordNode, finalWord);
                this._showEveryOtherEls(everyOtherEls);
              }, timing - 500);
            }
          }, timing);
        }            
      });   
    }     
  }

  _showFinalWord(finalWordNode, finalWord) {
    finalWordNode.removeAttribute("style");
    finalWordNode.textContent = finalWord;
  }

  _showEveryOtherEls(arr) {
    arr?.forEach(el => {
      if (el !== null && el !== undefined) {
        el.style.pointerEvents = "all";
        el.style.transition = "all ease-in-out .5s";

        setTimeout(() => {
          el.style.opacity = 1;
          
          setTimeout(() => {
            document.querySelector("html").classList.remove("overflow-hidden");
            document.querySelector("html").style.height = "auto";
            this.page.style.backgroundColor = "unset";
          }, 500);
        }, 500);
      }
    });
  }

  // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
  initTabs() {
    const tabs = this.page.querySelectorAll('[role="tab"]');
    const tabList = this.page.querySelector('[role="tablist"]');
    const swiperThumb = this.page.querySelector(".js-hubs-controller-scrollbar-thumb");
    const btnNext = this.page.querySelector(".js-hubs-controller-button-next");
    const btnPrev = this.page.querySelector(".js-hubs-controller-button-prev");
    
    // Add a click event handler to each tab
    tabs?.forEach((tab) => {
      tab.addEventListener("click", this._changeTabs.bind(this));
    }); 

    if (swiperThumb) {
      swiperThumb.style.width = `${tabs[0].offsetWidth}px`;
    }
  
    // Enable arrow navigation between tabs in the tab list
    let tabFocus = 0;
  
    // CODE BELOW COULD BE DRYER...
    tabList?.addEventListener("keydown", (e) => {
      // Move right
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        tabs[tabFocus].setAttribute("tabindex", -1);
        
        if (e.key === "ArrowRight") {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
        
          // Move left
        } else if (e.key === "ArrowLeft") {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }
  
        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();

        this._swipeTabsController(tabs[tabFocus]);
      }
    });
    
    btnNext?.addEventListener("click", (e) => {
      tabs[tabFocus].setAttribute("tabindex", -1);
      tabFocus++;
      if (tabFocus >= tabs.length) {
        tabFocus = 0;
      }
      tabs[tabFocus].click();
      this._swipeTabsController(tabs[tabFocus]);
    });

    btnPrev?.addEventListener("click", (e) => {
      tabs[tabFocus].setAttribute("tabindex", -1);
      tabFocus--;
      if (tabFocus < 0) {
        tabFocus = tabs.length - 1;
      }
      tabs[tabFocus].click();
      this._swipeTabsController(tabs[tabFocus]);
    });
    // CODE ABOVE COULD BE DRYER...
  }

  _changeTabs(e) {
    const target = e.target;
    const parent = target.closest(".hubs-controller");
    const grandparent = parent.closest(".hubs");
  
    // Remove all current selected tabs
    parent
      .querySelectorAll('[aria-selected="true"]')
      .forEach((t) => t.setAttribute("aria-selected", false));
  
    // Set this tab as selected
    target.setAttribute("aria-selected", true);
    this._swipeTabsController(target);
  
    // Hide all tab panels
    grandparent
      .querySelectorAll('[role="tabpanel"]')
      .forEach((p) => p.setAttribute("hidden", true));
  
    // Show the selected panel
    grandparent.parentNode
      .querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");

    this.page.querySelector(".js-hub-service.is-active")?.classList.remove("is-active");
    this.page.querySelector(".js-hub-service-thumb.is-visible")?.previousElementSibling?.classList.remove("is-hidden");
    this.page.querySelector(".js-hub-service-thumb.is-visible")?.classList.remove("is-visible");
  }

  _swipeTabsController(target) {
    const swiperThumb = this.page.querySelector(".js-hubs-controller-scrollbar-thumb");
    const wrapper = target.parentNode;
    wrapper.style.cssText = `transform: translate3d(-${target.previousElementSibling ? target.offsetLeft : 0}px, 0, 0)`;
    if (swiperThumb) {
      swiperThumb.style.width = `${target.offsetWidth}px`;
    }
  }
  
  initInlineBlocks() {
    const sectionInlineBlocks = this.page.querySelector(".js-section-inline-blocks");

    // if (sectionInlineBlocks) {
    //   const blocks = sectionInlineBlocks.querySelectorAll(".section-block");

    //   blocks?.forEach(block => {
    //     this._evenNextBlockSpacing(block);
    //   });
    // }
  }

  _evenNextBlockSpacing(block) {
    let hasHeight = false;

    const timer = setInterval(() => {
      const swiper = block.querySelector(".swiper");

      if (swiper?.offsetHeight && swiper?.offsetWidth) {
        if (swiper?.offsetHeight > swiper?.offsetWidth) {
          block.classList.add("has-margin-bottom-neg");
        }  
        
        clearInterval(timer);
      }
    }, 250);
  }

  initBookLoftForm() {
    const forms = this.page.querySelectorAll(".js-form-book-loft");
    forms?.forEach((form, i) => {
      const bookLoftForm = new BookLoftForm(form, i, this.data);
      bookLoftForm.init();      
    });
  }

  initBeersForms() {
    const beers = this.page.querySelectorAll(".js-beer-quantity");
    beers?.forEach((beer) => {
      const btnDecrease = beer.querySelector(".js-quantity-decrease");
      const btnIncrease = beer.querySelector(".js-quantity-increase");
      const input = beer.querySelector(".js-quantity");
      const btnSubmit = beer.querySelector(".js-btn-buy-beer");
      let baseUrl = btnSubmit.href;

      if (baseUrl.charAt(baseUrl.length - 1) === "/") {
        baseUrl = baseUrl.slice(0, -1);
      }      
      
      if (input) {
        btnDecrease?.addEventListener("click", (e) => {
          if (input.value > 0) {
            input.value = parseInt(input.value--) > 0 ? parseInt(input.value--) : 0;         
          }                  
        });

        btnIncrease?.addEventListener("click", (e) => {
          input.value = parseInt(input.value++) >= 0 ? parseInt(input.value++) : 0;         
        });
        
        btnSubmit?.addEventListener("click", (e) => {
          // e.preventDefault();          
          btnSubmit.href = baseUrl + `?id=${beer.closest(".beer").dataset.id}&quantity=${input.value}`; 
          console.log(btnSubmit.href);
        })
      }      
    });
  }

  initEventsAccordions() {
    const btnAccordions = this.page.querySelectorAll(".js-btn-accordion");
    btnAccordions?.forEach((btn) => {
      const panel = btn.nextElementSibling;
      if (panel) {
        const panelH = panel.offsetHeight;
                
        btn.addEventListener("click", this._toggleAccordion.bind(this, btn, panel, panelH, btnAccordions));

        if (!btn.classList.contains("is-open")) {
          panel.style.height = 0;
          panel.style.paddingBottom = 0;
        }
      }
    }); 
  }

  _toggleAccordion(btn, panel, panelH, btnAccordions) {
    btnAccordions?.forEach(sibling => { 
      if (sibling !== btn) {
        sibling.classList.remove("is-open");
        sibling.setAttribute("aria-expanded", false);

        if (sibling.nextElementSibling) {
          sibling.nextElementSibling.style.height = 0;
          sibling.nextElementSibling.style.paddingBottom = 0;
        }
      }  
    })
    let toggling; 
    if (!btn.classList.contains("is-open")) {      
      btn.setAttribute("aria-expanded", true);
      btn.classList.add("is-open");
      panel.style.height = `${panelH}px`;
      toggling = setTimeout(() => {
        panel.style.height = "auto";
      }, 200);

    } else {
      clearTimeout(toggling);
      btn.setAttribute("aria-expanded", false);
      btn.classList.remove("is-open");
      panel.style.height = 0;
      panel.style.paddingBottom = 0;
    }
  }

  initHubServicesThumbs() {
    const btns = this.page.querySelectorAll(".js-hub-service");
    let timeOut;

    btns?.forEach(btn => {      
      if (btn.dataset.img?.length) {
        btn.addEventListener("click", (e) => {
          clearTimeout(timeOut);
  
          if (this.page.querySelector(".js-hub-service-thumb.is-visible")) {
            btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.previousElementSibling?.classList.add("is-hidden");
          
          } else {
            btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.previousElementSibling?.classList.remove("is-hidden");
          }
  
          if (this.page.querySelector(".js-hub-service.is-active") !== btn) {
            this.page.querySelector(".js-hub-service.is-active")?.classList.remove("is-active");
            btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.classList.remove("is-visible");          
          }
          
          if (!btn.classList.contains("is-active")) {
            btn.classList.add("is-active");
            
            timeOut = setTimeout(() => {
              btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.setAttribute("src", btn.dataset.img);
              btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.classList.add("is-visible");
            }, 200);
          
          } else {
            btn.classList.remove("is-active");
            btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.classList.remove("is-visible");
            btn.closest(".hub")?.querySelector(".js-hub-service-thumb")?.previousElementSibling?.classList.remove("is-hidden");
          }
        });
      }          
    });
  }
}